import { useState } from 'react'

import taskDetailJson from '../../demo/fixtures/task-detail.json'
import { Button, Icon, Input, Modal, Spinner } from '../../ui'
import styles from './TaskDetailPage.module.css'

interface LinkFixDialogProps {
  open: boolean
  initialUrl: string
  onClose: () => void
  onFixed: (url: string) => void
}

function validLink(value: string): boolean {
  const trimmed = value.trim()
  return trimmed.includes('.') && !trimmed.includes(' ')
}

export function LinkFixDialog({ open, initialUrl, onClose, onFixed }: LinkFixDialogProps) {
  const [url, setUrl] = useState(initialUrl)
  const [status, setStatus] = useState<'idle' | 'verifying' | 'success'>('idle')
  const [visibleSteps, setVisibleSteps] = useState(0)
  const [error, setError] = useState(false)
  const verify = async () => {
    if (!validLink(url)) {
      setError(true)
      return
    }
    setError(false)
    setStatus('verifying')
    setVisibleSteps(1)
    const stepMs = taskDetailJson.linkFix.verifyMs / 3
    for (let step = 1; step <= 3; step += 1) {
      await new Promise((resolve) => window.setTimeout(resolve, stepMs))
      if (step < 3) setVisibleSteps(step + 1)
    }
    onFixed(url.trim())
    setStatus('success')
    window.setTimeout(onClose, taskDetailJson.linkFix.closeAfterMs)
  }
  let host = url
  try { host = new URL(url).host } catch { /* Keep the typed value visible. */ }
  const verifySteps = [`正在请求 ${host}`, '响应 200，商品页可访问', '商品在售']
  const footer = status === 'success' ? null : <><Button variant="ghost" disabled={status === 'verifying'} onClick={onClose}>取消</Button><Button disabled={status === 'verifying'} onClick={() => void verify()}>{status === 'verifying' ? '校验中…' : '校验并更新'}</Button></>
  return (
    <div data-scope={open ? 'state-link-fix' : undefined}>
      <Modal open={open} title={taskDetailJson.linkFix.dialogTitle} hint={taskDetailJson.linkFix.dialogHint} onClose={status === 'verifying' ? () => undefined : onClose} footer={footer}>
        {status === 'success' ? <div className={styles.linkSuccess}><Icon name="check-circle" size={22} strokeWidth={2} /><div><b>{taskDetailJson.linkFix.successText}</b><span>商品在售</span></div></div> : <><Input value={url} forceFocus={status === 'verifying'} error={error} disabled={status === 'verifying'} icon={status === 'verifying' ? <Spinner /> : <Icon name="link" size={19} />} onChange={(event) => setUrl(event.target.value)} />{status === 'verifying' ? <div className={styles.linkVerifySteps}>{verifySteps.slice(0, visibleSteps).map((step, index) => <p key={step}><Icon name={index === visibleSteps - 1 ? 'clock' : 'check-circle'} size={15} />{step}</p>)}</div> : null}{error ? <p className={styles.dialogError}>请填写一个商品页面链接</p> : null}</>}
      </Modal>
    </div>
  )
}
